import React from 'react';
import { Phone, Award, Shield } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center pt-20">
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1632759145351-1d592919f522)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 z-10 hero-overlay" />

      {/* Content */}
      <div className="container mx-auto px-4 z-20 relative">
        <div className="max-w-3xl">
          <div className="animate-fade-in-up">
            <div className="inline-flex items-center space-x-2 bg-primary/20 backdrop-blur-sm border border-primary/30 rounded-full px-4 py-2 mb-6">
              <Shield className="w-4 h-4 text-primary" />
              <span className="text-sm font-medium text-white">Licensed & Insured</span>
            </div>
            
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Trusted Roofing
              <br />
              <span className="text-primary">Excellence</span> in Central Florida
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
              {companyInfo.tagline}. Specializing in metal, shingles, tile roofing and more. Serving {companyInfo.serviceArea}.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button
                onClick={scrollToContact}
                size="lg"
                className="btn-primary bg-primary hover:bg-primary/90 text-white px-8 py-6 text-lg font-semibold"
              >
                Get Your Free Estimate
              </Button>
              <div className="flex flex-col sm:flex-row gap-3">
                {companyInfo.phones.map((phone, index) => (
                  <a key={index} href={`tel:${phone.number.replace(/\D/g, '')}`}>
                    <Button
                      size="lg"
                      variant="outline"
                      className="w-full sm:w-auto border-2 border-white text-white hover:bg-white hover:text-secondary px-6 py-6 text-lg font-semibold"
                    >
                      <Phone className="w-5 h-5 mr-2" />
                      {phone.number}
                    </Button>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap gap-8 items-center">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <p className="text-white font-bold text-lg">15+ Years</p>
                  <p className="text-gray-300 text-sm">Experience</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <Shield className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <p className="text-white font-bold text-lg">Fully Licensed</p>
                  <p className="text-gray-300 text-sm">& Insured</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-primary/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <Award className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <p className="text-white font-bold text-lg">100% Satisfaction</p>
                  <p className="text-gray-300 text-sm">Guaranteed</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
